import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class BuscaPromptService {
  private baseUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) {}

  searchPrompts(
    searchTerm: string,
    page: number = 0,
    size: number = 10,
    sort: string = 'title'
  ): Observable<any> {
    const termo =
      searchTerm === undefined || searchTerm === null
        ? ''
        : String(searchTerm).trim();
    if (termo === '') {
      return this.searchSemValue(page, size, sort);
    }
    return this.searchComTermo(termo, page, size, sort);
  }

  private normalizeSort(sort: string, fallback: string): string {
    const s = (sort ?? '').trim();
    return s === '' ? fallback : s;
  }

  private normalizeOrder(sort: string): 'asc' | 'desc' {
    const s = this.normalizeSort(sort, 'relevancia');
    return s === 'totalAvaliacoes' ? 'desc' : 'asc';
  }

  /** Backend aceita `search` ou `value`; usamos s� `search` no front para padronizar com a rota. */
  private searchComTermo(
    search: string,
    page: number,
    size: number,
    sort: string
  ) {
    const sortNorm = this.normalizeSort(sort, 'relevancia');
    const order = this.normalizeOrder(sortNorm);
    const params: Record<string, string> = {
      value: search,
      page: page.toString(),
      size: size.toString(),
      sort: sortNorm,
      order,
    };
    return this.http.get<any>(`${this.baseUrl}/search/`, { params });
  }

  private searchSemValue(page: number, size: number, sort: string) {
    const sortNorm = this.normalizeSort(sort, 'title');
    const order = this.normalizeOrder(sortNorm);
    const params: Record<string, string> = {
      page: page.toString(),
      size: size.toString(),
      sort: sortNorm,
      order,
    };
    return this.http.get<any>(`${this.baseUrl}/search/`, { params });
  }
}
